module.exports = __webpack_public_path__ + "static/img/ISO14001_Shulin.aa2a421f.jpg";